import { render, staticRenderFns } from "./EmbedSlider.vue?vue&type=template&id=3a989f20&scoped=true"
import script from "./EmbedSlider.vue?vue&type=script&lang=js"
export * from "./EmbedSlider.vue?vue&type=script&lang=js"
import style0 from "./EmbedSlider.vue?vue&type=style&index=0&id=3a989f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a989f20",
  null
  
)

export default component.exports